import { useAuthStore } from "@/stores/auth";

export default [
  {
    path: "/login",
    name: "login",
    meta: {
      title: "Login",
      guestOnly: true,
    },
    component: () => import("../views/account/login"),
  },
  {
    path: "/",
    name: "default",
    meta: {
      title: "Dashboard",
      authRequired: true,
    },
    component: () => import("../views/dashboard/index"),
  },
  {
    path: "/purchase-requests",
    name: "purchase-request",
    meta: {
      title: "Purchase Request",
      authRequired: true,
    },
    component: () => import("../views/pr/index"),
  },
  {
    path: "/request-form/:id/edit",
    name: "purchase-request-edit",
    meta: {
      title: "Edit Purchase Request",
      authRequired: true,
    },
    component: () => import("../views/pr/edit"),
    props: true,
  },
  {
    path: "/request-form",
    name: "purchase-request-form",
    meta: {
      title: "Purchase Request Form",
      authRequired: true,
    },
    component: () => import("../views/pr/create"),
  },
  {
    path: "/purchase-requests/show",
    name: "purchase-request-bulk-show",
    meta: {
      title: "Purchase Request Bulk Detail",
      authRequired: true,
    },
    component: () => import("../views/pr/detail"),
    props: (route) => ({ nos: route.query.nos }),
  },
  {
    path: "/purchase-requests/:id",
    name: "purchase-request-detail",
    meta: {
      title: "Purchase Request Detail",
      authRequired: true,
    },
    component: () => import("../views/pr/detail"),
    props: true,
  },
  {
    path: "/purchase-orders",
    name: "purchase-order",
    meta: {
      title: "Purchase Order",
      authRequired: true,
    },
    component: () => import("../views/po/index"),
  },
  {
    path: "/order-create",
    name: "order-create",
    meta: {
      title: "Purchase Order Entry",
      authRequired: true,
    },
    component: () => import("../views/po/create"),
  },
  {
    path: "/purchase-orders/:id",
    name: "purchase-order-detail",
    meta: {
      title: "Purchase Order Detail",
      authRequired: true,
    },
    component: () => import("../views/po/detail"),
    props: true,
  },
  {
    path: "/order-show",
    name: "order-show",
    meta: {
      title: "Purchase Order Detail",
      authRequired: true,
    },
    component: () => import("../views/po/detail"),
    props: (route) => ({ ids: route.query.ids }),
  },
  {
    path: "/order-edit/:id",
    name: "order-edit",
    meta: {
      title: "Purchase Order Edit",
      authRequired: true,
    },
    component: () => import("../views/po/edit"),
    props: true,
  },
  {
    path: "/items",
    name: "items",
    meta: {
      title: "Master Items",
      authRequired: true,
    },
    component: () => import("../views/items/index"),
  },
  {
    path: "/stock-in-list",
    name: "stock-in-list",
    meta: {
      title: "Stock In List",
      authRequired: true,
    },
    component: () => import("../views/items/stock-list"),
  },
  {
    path: "/stock-out-list",
    name: "stock-out-list",
    meta: {
      title: "Stock Out List",
      authRequired: true,
    },
    component: () => import("../views/items/stock-list"),
  },
  {
    path: "/hierarchies",
    name: "hierarchies",
    meta: {
      title: "Approval Hierarchy",
      authRequired: true,
    },
    component: () => import("../views/hierarchies/index"),
  },
  {
    path: "/sla-reports",
    name: "sla-reports",
    meta: {
      title: "SLA & PIC Leaderboard",
      authRequired: true,
    },
    component: () => import("../views/hierarchies/SlaReports.vue"),
  },
  {
    path: "/users",
    name: "users",
    meta: {
      title: "User Management",
      authRequired: true,
    },
    component: () => import("../views/users/index"),
  },
  {
    path: "/users/create",
    name: "users-create",
    meta: {
      title: "Create User",
      authRequired: true,
    },
    component: () => import("../views/users/create"),
  },
  {
    path: "/users/:id/edit",
    name: "users-edit",
    meta: {
      title: "Edit User",
      authRequired: true,
    },
    component: () => import("../views/users/edit"),
  },
  {
    path: "/logout",
    name: "logout",
    beforeEnter() {
      const authStore = useAuthStore();
      authStore.logout();
      // No need to call next() - logout() handles redirection
    },
  },

  {
    path: "/po-cancel-approval",
    name: "po-cancel-approval",
    meta: {
      title: "Persetujuan Pembatalan Purchase Order",
      authRequired: false,
      publicAccess: true,
    },
    component: () => import("../views/po/CancelApproval.vue"),
  },
  {
    path: "/po-approval",
    name: "po-approval",
    meta: {
      title: "Persetujuan Approval Purchase Order [GMFA]",
      authRequired: false,
      publicAccess: true,
    },
    component: () => import("../views/po/PoApproval.vue"),
  },
  {
    path: "/verify/po/:token",
    name: "po-verify",
    meta: {
      title: "Verify Purchase Order",
      authRequired: false,
    },
    component: () => import("../views/po/PoVerify.vue"),
    props: true,
  },
  {
    path: "/purchase/tracking/search",
    name: "tracking-search",
    component: () => import("../views/pr/tracking-search.vue"),
    meta: {
      title: "Purchase Request Tracking",
      layout: "tracking",
    },
  },
  {
    path: "/purchase/tracking",
    name: "purchase-request-tracking",
    meta: {
      title: "Purchase Request Tracking",
      authRequired: false, // Make it accessible even without auth, or with minimal auth
      publicAccess: true,
    },
    component: () => import("../views/pr/tracking.vue"),
  },

  // ── Procurement routes (auth required for offices access) ─────────────────
  {
    path: "/procurement",
    name: "procurement",
    meta: {
      title: "Procurement",
      authRequired: true,
      dashboard: "procurement",
    },
    component: () => import("../views/procurement/index.vue"),
  },
  {
    path: "/procurement/request-form",
    name: "procurement-request-form",
    meta: {
      title: "Procurement PR Form",
      authRequired: true,
      dashboard: "procurement",
    },
    component: () => import("../views/procurement/create.vue"),
  },
  {
    path: "/procurement/request-form/:id/edit",
    name: "procurement-request-form-edit",
    meta: {
      title: "Procurement Edit PR Form",
      authRequired: true,
      dashboard: "procurement",
    },
    component: () => import("../views/procurement/edit.vue"),
  },
  {
    path: "/procurement/po/:id",
    name: "procurement-purchase-order-detail",
    meta: {
      title: "Procurement PO Detail",
      authRequired: true,
      dashboard: "procurement",
    },
    component: () => import("../views/procurement/po-detail.vue"),
  },
  {
    path: "/procurement/:id",
    name: "procurement-purchase-request-detail",
    meta: {
      title: "Procurement PR Detail",
      authRequired: true,
      dashboard: "procurement",
    },
    component: () => import("../views/procurement/detail.vue"),
    props: true,
  },
];
